export default "__VITE_ASSET__DyCLbJzQ__"